const isLocalhost = window.location.hostname === 'localhost'
const PATHS = {
    SINIESTROS_EMPRESA: '/siniestros-empresa',
    SINIESTROS: '/siniestros',
    PLAN_MOVILIDAD: '/plan-movilidad',
    COTIZACIONES: '/cotizaciones',
    EMPRESAS_ACHS: '/empresas-achs',
    CONTACT_CENTER: '/contact-center',
}
export const isIframe = (window.location !== window.parent.location) || isLocalhost;

export const getRouteIframe = () => localStorage.getItem('navigate');

export const getStylesFromAV2 = () => localStorage.getItem('cross-style');

export const getCurrentCompanyAV2 = () => localStorage.getItem('rutEnterprise')

export const outsideSSOIframes = () => window.location.pathname !== getRouteIframe();

export const isAuthenticated = () => localStorage.getItem('AccessToken') !== undefined

export const setRedirectionToInicio = () => localStorage.setItem('redirection', 'true')
export const AtSomeIframeSSOPage = () => {
    const current = window.location.pathname
    switch (current) {
        case (PATHS.SINIESTROS_EMPRESA):
            return true
        case (PATHS.SINIESTROS):
            return true
        case (PATHS.PLAN_MOVILIDAD):
            return true
        case (PATHS.COTIZACIONES):
            return true
        case (PATHS.EMPRESAS_ACHS):
            return true
        case (PATHS.CONTACT_CENTER):
            return true
        default:
            return false
    }
}